import { FC, SVGProps } from 'react';

const NotificationIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M8.27734 16.6455C8.69733 17.1701 9.32733 17.5001 10.0246 17.5001C10.7292 17.5001 11.3592 17.1701 11.7792 16.6455"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.88672 11.6644C4.06834 13.8423 5.94453 14.3847 9.99934 14.3847C14.0533 14.3847 15.9295 13.8496 16.1119 11.6644C16.1119 9.48825 14.8033 9.62775 14.8033 6.95777C14.8033 4.87239 12.9077 2.5 9.99934 2.5C7.09099 2.5 5.19535 4.87239 5.19535 6.95858C5.19535 9.6285 3.88672 9.48992 3.88672 11.6644Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default NotificationIcon;
